module.exports = __webpack_public_path__ + "static/media/kneehyperextension_normal_right.6df508d9.png";